/**
 * El aviso de agencia de demostración (decisión del 27-sep): quien vea una demostración no debe
 * poder tomar esos datos por operación real. Una agencia real no lo lleva y aquí no pinta nada.
 */
export function DemoBanner({ notice }: { notice?: string | null }) {
  if (!notice?.trim()) return null
  return <div className="demo-banner" role="note">{notice.trim()}</div>
}
